/**
 * 文件进出。
 *
 * 「未修改不落盘」的实现基础：`svgTextForExport` 在 pristine 时**直接返回原始字符串**，
 * 于是「打开 → 不改 → 导出」得到的是字节级相同的文件（比走一遍 XMLSerializer 更保守）。
 */
import type { Header } from '../io/header';
import { serializeSvg } from '../io/serialize';

export interface ExportInput {
  svg: Element;
  header: Header;
  /** 打开时的原文 */
  rawSource: string | null;
  /** 尚未产生任何命令（或全部撤销） */
  pristine: boolean;
}

export function svgTextForExport({ svg, header, rawSource, pristine }: ExportInput): string {
  if (pristine && rawSource !== null) return rawSource;
  return serializeSvg(svg, header);
}

export const svgBlob = (text: string): Blob =>
  new Blob([text], { type: 'image/svg+xml;charset=utf-8' });

export const readFileText = (file: File): Promise<string> => file.text();

/** 浏览器下载（副作用集中在 UI 层，测试不覆盖） */
export function downloadFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
